module.exports = require("highlight.js/lib/languages/bash");